'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import NextErrorPage from 'next/error';

export default function ErrorPage({
  error,
  statusCode,
}: {
  error: Error & { digest?: string };
  statusCode: number;
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return <NextErrorPage statusCode={statusCode} />;
}
